import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { computed } from "vue";
import { useUser } from "@rmp/core/composables/useUser";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpAccessDeniedError',
  setup(__props) {

const { signOut } = useUser();

const canGoBack = computed(() => {
	return history.length > 2;
});

const { colors } = useColors();

return { __sfc: true,signOut, canGoBack, colors, RmpText }
}

})